import { FC, ReactNode, useEffect, useState } from "react";
import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
} from "mdb-react-ui-kit";
import { ModalSize } from "@/models/common/enums";
import styles from "@/styles/common/InfoModal.module.scss";
import { useDisableBodyScroll } from "@/hooks/useDisableBodyScroll";

const ModalCartContainer: FC<{
    children: ReactNode;
    modalSize?: ModalSize;
    show: boolean;
    setShow: (state: boolean) => void;
}> = ({ children, modalSize = ModalSize.FULL, show, setShow }) => {
    const [isBrowser, setIsBrowser] = useState(false);
    useEffect(() => {
        setIsBrowser(typeof window !== "undefined");
    }, []);
    const toggleShow = () => setShow(!show);

    useDisableBodyScroll(show);

    return isBrowser ? (
        <MDBModal
            show={show}
            setShow={setShow}
            tabIndex="-1"
            className="bottom p-0"
            staticBackdrop
        >
            <MDBModalDialog
                centered
                size={modalSize === ModalSize.MD ? undefined : modalSize}
            >
                <MDBModalContent>
                    <MDBModalBody className="p-0">
                        <MDBBtn
                            className={`${styles.closeButtonCart} btn-close`}
                            color="none"
                            onClick={toggleShow}
                        />
                        {children}
                    </MDBModalBody>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    ) : (
        <div />
    );
};

export default ModalCartContainer;
